import DomaQuery from "../../domain/core/payments/DomaQuery";
import { DomaModel } from "../../domain/models/Doma";
import { IQueryDomaRepository } from "../../domain/ports/payments/IQueryDomaRepository";
import QueryService from "../QueryService";

export class DomaQueryService
  extends QueryService<DomaModel>
  implements IQueryDomaRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
    this.api.defaults.headers.common.Accept = "application/json";
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const domaQuery = new DomaQuery(new DomaQueryService(BASE_URL, "domas"));

export { domaQuery };
